(function($){

    // parallax des bannière
    $('.with-parallax').each(function(){
        $(this).children('img').parallax($(this),4,-1);
    });

    // parallax de la bannière générale
    if($('.banner-parallax').length){
        $('.banner-parallax img').parallax($('.banner'),4,-1);
    }

    var rellax = new Rellax('.rellax',{
        breakpoints:[768,960,1200] 
    });

    // Ajouter et enlève une classe qui change le design du header su la page home selon la position du scroll
    if(document.querySelector('body.home')){
        const leBody = document.querySelector('body.home');
        let observer = new IntersectionObserver(entries => {
            if (entries[0].boundingClientRect.y < window.innerHeight) {
                leBody.classList.add('is-past-fold');
            } else {
                leBody.classList.remove('is-past-fold');
            }
        });
        observer.observe(document.querySelector("#fold-pixel"));
    }
    


})(jQuery);